<template>
	<div class="content" :class="{ 'essay-nopad': fit_to_content }">
        <div class="row">
            <div class="col-12">

     		<span class="label text-theme" v-if="page.title">{{ page.title }}</span>
        
		<p class="respText">
			<span v-if="page.preventRenderHTML">{{ page.text }}</span>
			<span v-if="!page.preventRenderHTML" v-html="page.text"></span>
		</p>           
            </div>

        </div>

	</div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import store from "@/services/Store";
import Utils from "@/services/Utils";

export default {
	name: "HTMLMedia",
	props: ["page", "chan", "zoom", "item"],
	data() {
		return {
			events: [],
			sizes: ["16px", "18px", "20px", "22px", "24px"],
			fit_to_content: false
		};
	},

	created() {
		if (this.item && this.item.fit_to_content) {
			this.fit_to_content = true;
		}

		var zoom = () => {
			var ele = this.$refs.essay;
			var size = store.get(this, "viewerScale");
			var px = this.sizes[size];
			$(ele).css("font-size", px);
		};
		this.events.push({ key: "zoom-in", val: zoom });
		this.events.push({ key: "zoom-out", val: zoom });
		this.chan.$on("zoom-in", zoom);
		this.chan.$on("zoom-out", zoom);

		var invert = () => {
			$(this.$refs.essay).toggleClass("inverted");
		};
		this.events.push({ key: "invert", val: invert });
		this.chan.$on("invert", invert);

	},

	mounted() {
		var zoom = store.get(this, "viewerScale");
		var size = this.sizes[zoom] || this.sizes[1];
		$(this.$refs.essay).css("font-size", size);
		Utils.throttleMathJAX();
		$("p img").css({"max-width": "100%", "max-height": "100%","display":"block"});

	},

	destroyed() {
		var _this = this;
		_.each(this.events, e => {
			_this.chan.$off(e.key, e.val);
		});
	},

	methods: {}
};
</script>

<style scoped>
.inverted {
	background-color: black;
	color: white;
}
.label {
	position: relative;
	top: 10px;
	left: 15px;
}
.respText{
    overflow: auto
}
.imagedropshadow{
	max-width: 100%;
	max-height: 100%;
	display: block; /* remove extra space below image */
}
</style>



// WEBPACK FOOTER //
// src/components/viewer/HTMLMedia.vue